(() => {
  if (window.HKUniformDelivery) return;
  const endpoint = 'https://hk-configurator.hoopsking.workers.dev/api/resto-capacity';
  const maxAge = 48 * 60 * 60 * 1000;
  const names = { standard: 'Standard', expedited: 'Expedited', rush: 'Rush', economy: 'Economy' };
  let pending, current;
  function normalize(feed, now = Date.now()) {
    const captured = Date.parse(feed?.capturedAt || '');
    if (!Number.isFinite(captured) || now - captured > maxAge || captured - now > 5 * 60 * 1000) throw new Error('Delivery schedule needs confirmation');
    const tiers = [];
    for (const key of ['standard', 'expedited', 'rush', 'economy']) {
      const raw = feed.tiers?.find(t => t.key === key);
      const weeks = raw?.weeks;
      if (!Number.isInteger(weeks) || weeks < 1 || weeks > 12 || /not (?:currently )?available/i.test(raw.windowText || '')) continue;
      const express = key === 'expedited' || key === 'rush';
      const match = String(raw.priceModifier || '').match(/^\+(\d+(?:\.\d+)?)\s*%/);
      const percent = match ? Number(match[1]) : null;
      if (express && (percent == null || percent <= 0 || percent > 100)) continue;
      // Resto disables ALL selection buttons until a product is picked. Its global disabled
      // flag does not mean a published speed is unavailable; missing timing does (Economy today).
      tiers.push({ key, name: names[key], weeks, percent: express ? percent : 0, fixedFee: 0,
        window: `Within ${weeks} week${weeks === 1 ? '' : 's'}` });
    }
    if (!tiers.length) throw new Error('No current delivery options');
    return { capturedAt: feed.capturedAt, period: String(feed.currentPeriod || ''), tiers };
  }
  function hkShipFee(sub){ // Resto freight recovery: % of the uniform subtotal, $30 floor, whole dollars. Duplicated in the designer, the quote form and assets/hk-uniform-delivery.js; scripts/tests/ptc-shipping-rule.test.mjs fails if the copies drift. NOTE: neither Make engine recomputes this yet, so a stale page can still post an old fee.
    if(!(sub>0)||!isFinite(sub)) return 0;
    var r=sub<1500?0.07:sub<4500?0.065:sub<7500?0.06:0.055;
    return Math.max(30,Math.round(sub*r));
  }
  function fee(tier, subtotal) {
    if (!tier || !Number.isFinite(subtotal) || subtotal < 0) throw new Error('Delivery selection needs confirmation');
    // Every speed pays the base shipping (banded % of subtotal, $30 floor); Expedited/Rush add
    // Resto's published surcharge on top, because Resto bills its surcharge on top of its shipping.
    return Math.round((hkShipFee(subtotal) + subtotal * tier.percent / 100) * 100) / 100;
  }
  function load(force = false) {
    if (current && !force && Date.now() - Date.parse(current.capturedAt) <= maxAge) return Promise.resolve(current);
    if (pending) return pending;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    pending = fetch(endpoint, { signal: controller.signal, credentials: 'omit', cache: 'no-store' })
      .then(r => { if (!r.ok) throw new Error('Delivery schedule unavailable'); return r.json(); })
      .then(feed => (current = normalize(feed)))
      .finally(() => { clearTimeout(timeout); pending = null; });
    return pending;
  }
  function forProduct(feed, product = {}) {
    return { ...feed, tiers: feed.tiers.filter(t => !product.delivery_no_express || !['expedited','rush'].includes(t.key)).map(t => {
      const weeks = Math.max(t.weeks, Number(product.delivery_minimum_weeks) || 0);
      return {...t, weeks, window: 'Within '+weeks+' week'+(weeks===1?'':'s')};
    }) };
  }
  const api = { normalize, fee, load, endpoint, forProduct };
  window.HKUniformDelivery = api;
  async function paint(root, force = false) {
    root.setAttribute('aria-busy', 'true');
    try {
      const feed = forProduct(await load(force), {delivery_no_express: root.dataset.noExpress === 'true', delivery_minimum_weeks: Number(root.dataset.minimumWeeks)});
      const list = document.createElement('ul'); list.className = 'hk-delivery-options';
      for (const tier of feed.tiers) {
        const item = document.createElement('li'), name = document.createElement('strong'), timing = document.createElement('span');
        name.textContent = tier.name; timing.textContent = tier.window; item.append(name, timing); list.append(item);
      }
      root.replaceChildren(list); root.dataset.deliveryState = 'ready';
    } catch {
      const text = document.createElement('p'), retry = document.createElement('button');
      text.textContent = 'Current delivery timing needs confirmation. Check again or confirm timing in AI Creator.';
      retry.type = 'button'; retry.className = 'hk-delivery-retry'; retry.textContent = 'Check delivery options again';
      retry.addEventListener('click', () => paint(root, true).then(() => { if (root.dataset.deliveryState === 'ready') mount(); })); root.replaceChildren(text, retry); root.dataset.deliveryState = 'unavailable';
    } finally { root.setAttribute('aria-busy', 'false'); }
  }
  function mount() { document.querySelectorAll('[data-hk-delivery]').forEach(root => paint(root)); }
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true }); else mount();
  }
})();
